import { Auth } from 'aws-amplify';

type ChangePasswordData = {
  oldPassword: string,
  newPassword: string,
};

export function changePassword(changePasswordData: ChangePasswordData): void {
  const { oldPassword, newPassword } = changePasswordData;
  Auth.currentAuthenticatedUser()
    .then(user => {
      return Auth.changePassword(user, oldPassword, newPassword);
    })
    .then(data => console.log(data))
    .catch(err => console.log(err));
}

export function forgotPassword(username: string ): void {
  Auth.forgotPassword(username)
    .then(data => console.log(data))
    .catch(err => console.log(err));
}

type ForgotPasswordData = {
  username: string,
  code: string,
  newPassword: string
};

export async function forgotPasswordSubmit(forgotPasswordData: ForgotPasswordData): Promise<void | string | unknown> {
  const { username, code, newPassword } = forgotPasswordData;
  try {
    await Auth.forgotPasswordSubmit(username, code, newPassword);
    return ('SUCCESS');
  } catch (error) {
    return (error);
  }
}
